export function copyStringToClipboard(str: string): void {
  const el: HTMLTextAreaElement = document.createElement('textarea');

  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
